import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'bringozDateRange'
})
export class BringozDateRangePipe implements PipeTransform {

  constructor(
      @Inject('splitService') private splitService,
      @Inject('dateRangeTimeFiltersService') private dateRangeTimeFiltersService
  ) {}

  transform(range: any, noNamesJustDates?: boolean, displayTime?: boolean): string {
    const dateFormat = this.splitService.getDateAndTimeConfig();

    if (!range || (
        (!range.from || !range.to) &&
        (!range.notBefore || !range.notAfter) &&
        (!range.startTime || !range.endTime)) &&
        (!range.dateStart || !range.dateEnd)
    ) {
      return '---';
    }

    const from = range.from || range.notBefore || range.startTime || range.dateStart;
    const to = range.to || range.notAfter || range.endTime || range.dateEnd;

    return this.dateRangeTimeFiltersService.getRangeDisplay(from, to, dateFormat, noNamesJustDates, displayTime);
  }
}
